// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import Vant from 'vant'
import ElementUI from 'element-ui'
import axios from "axios"
import VueClipboard from 'vue-clipboard2'
import request from './utils/request'
import bridge from './utils/bridge'

import { parseTime, isWeixin, isMobile, trimSpecial, infoTrimSpecial, toRegNum, checkPhone, checkTel, checkNumber, checkNumAndLetters, checkLetters } from './utils/index'
import { Toast } from 'vant';
import 'vant/lib/index.css'
import 'element-ui/lib/theme-chalk/index.css';

import './assets/font/font.css'

import ContactBtn from "@/components/ContactButton.vue";
import Loading from '@/components/Loading';
import Tab from '@/components/Tab'
import Tag from '@/components/Tag'
import HeaderNav from '@/components/HeaderNav'

import VConsole from 'vconsole';
// if (process.env.NODE_ENV == "development") { //如果是dev环境，就实例vConsole
//   new VConsole({ theme: "dark" });
// }
// new VConsole({ theme: "dark" });

Vue.use(Vant)
Vue.use(ElementUI);
Vue.use(VueClipboard)

Vue.config.productionTip = false
Vue.prototype.isWeixin = isWeixin
Vue.prototype.mobileTerminal = isMobile
Vue.prototype.trimSpecial = trimSpecial
Vue.prototype.infoTrimSpecial = infoTrimSpecial
Vue.prototype.toRegNum = toRegNum
Vue.prototype.checkPhone = checkPhone
Vue.prototype.checkTel = checkTel
Vue.prototype.checkNumber = checkNumber
Vue.prototype.checkNumAndLetters = checkNumAndLetters
Vue.prototype.checkLetters = checkLetters

Vue.prototype.$Request = request
Vue.prototype.Toast = Toast
Vue.prototype.parseTime = parseTime
Vue.prototype.$axios = axios

Vue.component('ContactBtn', ContactBtn)
Vue.component('Loading', Loading)
Vue.component('Tab', Tab)
Vue.component('Tag', Tag)
Vue.component('HeaderNav', HeaderNav)

// import Vconsole from 'vconsole';
// new Vconsole();

//路由拦截(引导用人)
router.beforeEach((to,from,next)=>{
  if (to.meta.title) {
    document.title = to.meta.title
  }
  if(to.query.phone) {
    sessionStorage.setItem('phone', to.query.phone);
  }
  if(to.query.userAscription) {
    sessionStorage.setItem('userAscription', to.query.userAscription);
  }
  if(to.query.isQuick) {
    sessionStorage.setItem('isQuick', to.query.isQuick);
  }
  if(to.query.isVip) {
    sessionStorage.setItem('isVip', to.query.isVip);
    sessionStorage.setItem('vipShopCode', to.query.shopCode);
  }
  if(to.query.quickAccessToken){
    sessionStorage.setItem('quickAccessToken', to.query.quickAccessToken);
  }
  // 分销入驻参数
  if(to.query.shopCode) {
    sessionStorage.setItem('shopCode', to.query.shopCode);
  }
  if(to.query.distributionType) {
    sessionStorage.setItem('distributionType', to.query.distributionType);
  }
  if(to.query.partnerCode&&to.query.partnerCode!=='null'&&to.query.partnerCode!=='undefined') {
    sessionStorage.setItem('partnerCode', to.query.partnerCode);
  }
  
  let phone = sessionStorage.getItem('phone');
  let userAscription = sessionStorage.getItem('userAscription');
  let isQuick = sessionStorage.getItem('isQuick');
  let quickAccessToken = sessionStorage.getItem('quickAccessToken');
  let isVip = sessionStorage.getItem('isVip');
  let flag = localStorage.getItem('flag');
  let distributionFlag = sessionStorage.getItem('distributionFlag');
  let shopCode = sessionStorage.getItem('shopCode');
  let distributionType = sessionStorage.getItem('distributionType');
  let partnerCode = sessionStorage.getItem('partnerCode');
  if(to.path==='/login'){
    if(!flag){
      if(to.meta.requireAuth){
        if(!phone&&!userAscription&&!isQuick) return next({path:'/guide'});
        if(phone&&userAscription&&isQuick&&quickAccessToken&&isVip) {
          next({path:'/guide?phone='+phone+'&userAscription=' + userAscription+'&isQuick='+isQuick+'&quickAccessToken='+quickAccessToken+'&isVip='+isVip})
        } else {
          if(userAscription) {
            if(isQuick){
              if(isVip){
                if(quickAccessToken){
                  next({path:'/guide?userAscription=' + userAscription+'&isQuick='+isQuick+'&quickAccessToken='+quickAccessToken+'&isVip='+isVip})
                } else{
                  next({path:'/guide?userAscription=' + userAscription+'&isQuick='+isQuick+'&isVip='+isVip})
                }
              } else {
                if(quickAccessToken){
                  next({path:'/guide?userAscription=' + userAscription+'&isQuick='+isQuick+'&quickAccessToken='+quickAccessToken})
                } else{
                  next({path:'/guide?userAscription=' + userAscription+'&isQuick='+isQuick})
                }
              }
            } else {
              if(isVip){
                if(quickAccessToken){
                  next({path:'/guide?userAscription=' + userAscription+'&quickAccessToken='+quickAccessToken+'&isVip='+isVip})
                }else{
                  next({path:'/guide?userAscription=' + userAscription+'&isVip='+isVip})
                }
              } else {
                if(quickAccessToken){
                  next({path:'/guide?userAscription=' + userAscription+'&quickAccessToken='+quickAccessToken})
                }else{
                  next({path:'/guide?userAscription=' + userAscription})
                }
              }
            }
          }
          if(phone){
            if(isQuick){
              if(isVip){
                if(quickAccessToken){
                  next({path:'/guide?phone='+phone+'&isQuick='+isQuick+'&quickAccessToken='+quickAccessToken+'&isVip='+isVip})
                } else {
                  next({path:'/guide?phone='+phone+'&isQuick='+isQuick+'&isVip='+isVip})
                }
              } else{
                if(quickAccessToken){
                  next({path:'/guide?phone='+phone+'&isQuick='+isQuick+'&quickAccessToken='+quickAccessToken})
                } else {
                  next({path:'/guide?phone='+phone+'&isQuick='+isQuick})
                }
              }
            } else {
              if(isVip){
                if(quickAccessToken){
                  next({path:'/guide?phone=' + phone+'&quickAccessToken='+quickAccessToken+'&isVip='+isVip})
                }else{
                  next({path:'/guide?phone='+phone+'&isVip='+isVip})
                }
              } else {
                if(quickAccessToken){
                  next({path:'/guide?phone=' + phone+'&quickAccessToken='+quickAccessToken})
                }else{
                  next({path:'/guide?phone='+phone})
                }
              }
            }
          }
        }
      } else {
        next()
      }
    } else {
      next()
    }
  } else {
    next()
  }
  if(to.path==='/distribution/login'){
    if(!distributionFlag){
      if(!shopCode&&!distributionType) return next({path:'/distribution/guide'});
      if(shopCode&&distributionType) {
        if(!partnerCode){
          next({path:'/distribution/guide?shopCode='+shopCode+'&distributionType='+distributionType})
        } else {
          next({path:'/distribution/guide?shopCode='+shopCode+'&distributionType='+distributionType+'&partnerCode='+partnerCode})
        }
      } else {
        if(distributionType) {
          if(!partnerCode){
            next({path:'/distribution/guide?distributionType=' + distributionType})
          } else {
            next({path:'/distribution/guide?distributionType=' + distributionType+'&partnerCode='+partnerCode})
          }
        }
        if(shopCode){
          if(!partnerCode){
            next({path:'/distribution/guide?shopCode='+shopCode})
          } else {
            next({path:'/distribution/guide?shopCode='+shopCode+'&partnerCode='+partnerCode})
          }
        }
      }
    } else {
      next()
    }
  } else {
    next()
  }
})

//  地图组件
import VueAMap from 'vue-amap';
Vue.use(VueAMap);
VueAMap.initAMapApiLoader({
  key: '0dc34d77fd11092e575ccb201f8ca693',
  securityJsCode:'e3bb8ac522c814dda694439e93102cfd',
  plugin: ['AMap.Autocomplete', 'AMap.PlaceSearch','AMap.Scale', 'AMap.OverView', 'AMap.ToolBar', 'AMap.MapType', 'AMap.Geolocation','AMap.Geocoder', 'AMap.AMapManager', 'AMap.Marker'],
  v: '1.4.4'
});
window._AMapSecurityConfig = {
  securityJsCode:'e3bb8ac522c814dda694439e93102cfd',
}
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js